class HttpClient {
    baseURL;
    antiForgeryToken;

    constructor(baseURL) {
        this.baseURL = baseURL;
        this.setAntiForgeryToken();
    }

    setAntiForgeryToken() {
        const token = document.querySelector('meta[name="anti-forgery-token"]');
        if (!token || !token.content) {
            throw new Error('Anti Forgery Token not found');
        }
        this.antiForgeryToken = token.content;
    }

    async post(endpoint, body, timeout = 10000) {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), timeout);

        try {
            const response = await fetch(this.baseURL + endpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    '__RequestVerificationToken': this.antiForgeryToken
                },
                body: JSON.stringify(body),
                signal: controller.signal
            });

            clearTimeout(timeoutId);

            if (!response.ok) {
                const errorMessage = await response.text();
                return Promise.reject(new Error(`HTTP error! status: ${response.status}, message: ${errorMessage}`));
            }

            const data = await response.json();

            if (!data) {
                return Promise.reject(new Error('No data found'));
            }

            return data;
        } catch (error) {
            if (error.name === 'AbortError') {
                return Promise.reject(new Error('Request timed out'));
            } else if (error instanceof SyntaxError) {
                return Promise.reject(new Error('Invalid JSON in response'));
            } else {
                return Promise.reject(error);
            }
        } finally {
            clearTimeout(timeoutId);
        }
    }
}

export default HttpClient;